import { getStaticUrl, getLiveStaticUrl } from '~/utils/static'

export default (_context: any, inject: any) => {
  inject('s', getStaticUrl)
  inject('ls', getLiveStaticUrl)
}
